import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
import { SaleFragmentDoc } from '../../fragments/__generated__/Sale.generated';
import { CategoryBaseWithThumbnailFragmentDoc } from '../../fragments/__generated__/CategoryWithThumbnail.generated';
import { ReflectionInfoFragmentDoc } from '../../fragments/__generated__/ReflectionInfo.generated';
import { ProductBaseInfoFragmentDoc } from '../../fragments/__generated__/Product.generated';
import { ProductPriceRangeFragmentDoc } from '../../fragments/__generated__/ProductPriceRange.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SalesWithCategoriesAndSpecificsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type SalesWithCategoriesAndSpecificsQuery = { saleList: { edges: Array<{ node: { id: string, pk: number, name: string, availableTo: any, availableFrom: any | null, type: string, value: any, categories: Array<{ thumbnailUrl: string | null, id: string, name: string, url: string, pk: number, slug: string, description: string, metaDescription: string, keywords: string, metaTitle: string, level: number, isWholesale: boolean, parent: { id: string } | null }> } }> }, specifics: { edges: Array<{ node: { id: string, pk: number, name: string, shortName: string, slug: string, videoUrl: string | null, product: { id: string, pk: number, name: string, sku: string | null, isInFavorites: boolean, isShippingRequired: boolean, isOutOfStock: boolean, thumbnail: { lg: string | null, sm: string | null }, priceRange: { id: string, currency: string, discount: { max: number, min: number }, undiscount: { max: number, min: number } } } | null } }> } };

export type SalesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type SalesQuery = { saleList: { edges: Array<{ node: { id: string, pk: number, name: string, availableTo: any, availableFrom: any | null, type: string, value: any } }> } };


export const SalesWithCategoriesAndSpecificsDocument = gql`
    query SalesWithCategoriesAndSpecifics {
  saleList(first: 10) {
    edges {
      node {
        ...Sale
        categories(filters: {level: {lte: 1}}) {
          ...CategoryBaseWithThumbnailFragment
          parent {
            id
          }
        }
      }
    }
  }
  specifics(first: 10, filters: {withSale: true}, ordering: {id: DESC}) {
    edges {
      node {
        ...ReflectionInfoFragment
        product {
          ...ProductBaseInfoFragment
          thumbnail {
            lg(method: CROP_WEBP)
            sm(size: "300x0", method: CROP_WEBP)
          }
          priceRange {
            ...ProductPriceRangeFragment
          }
        }
      }
    }
  }
}
    ${SaleFragmentDoc}
${CategoryBaseWithThumbnailFragmentDoc}
${ReflectionInfoFragmentDoc}
${ProductBaseInfoFragmentDoc}
${ProductPriceRangeFragmentDoc}`;

/**
 * __useSalesWithCategoriesAndSpecificsQuery__
 *
 * To run a query within a React component, call `useSalesWithCategoriesAndSpecificsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesWithCategoriesAndSpecificsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesWithCategoriesAndSpecificsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSalesWithCategoriesAndSpecificsQuery(baseOptions?: Apollo.QueryHookOptions<SalesWithCategoriesAndSpecificsQuery, SalesWithCategoriesAndSpecificsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SalesWithCategoriesAndSpecificsQuery, SalesWithCategoriesAndSpecificsQueryVariables>(SalesWithCategoriesAndSpecificsDocument, options);
      }
export function useSalesWithCategoriesAndSpecificsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SalesWithCategoriesAndSpecificsQuery, SalesWithCategoriesAndSpecificsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SalesWithCategoriesAndSpecificsQuery, SalesWithCategoriesAndSpecificsQueryVariables>(SalesWithCategoriesAndSpecificsDocument, options);
        }
export type SalesWithCategoriesAndSpecificsQueryHookResult = ReturnType<typeof useSalesWithCategoriesAndSpecificsQuery>;
export type SalesWithCategoriesAndSpecificsLazyQueryHookResult = ReturnType<typeof useSalesWithCategoriesAndSpecificsLazyQuery>;
export type SalesWithCategoriesAndSpecificsQueryResult = Apollo.QueryResult<SalesWithCategoriesAndSpecificsQuery, SalesWithCategoriesAndSpecificsQueryVariables>;
export function refetchSalesWithCategoriesAndSpecificsQuery(variables?: SalesWithCategoriesAndSpecificsQueryVariables) {
      return { query: SalesWithCategoriesAndSpecificsDocument, variables: variables }
    }
export const SalesDocument = gql`
    query Sales {
  saleList(first: 10) {
    edges {
      node {
        ...Sale
      }
    }
  }
}
    ${SaleFragmentDoc}`;

/**
 * __useSalesQuery__
 *
 * To run a query within a React component, call `useSalesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSalesQuery(baseOptions?: Apollo.QueryHookOptions<SalesQuery, SalesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SalesQuery, SalesQueryVariables>(SalesDocument, options);
      }
export function useSalesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SalesQuery, SalesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SalesQuery, SalesQueryVariables>(SalesDocument, options);
        }
export type SalesQueryHookResult = ReturnType<typeof useSalesQuery>;
export type SalesLazyQueryHookResult = ReturnType<typeof useSalesLazyQuery>;
export type SalesQueryResult = Apollo.QueryResult<SalesQuery, SalesQueryVariables>;
export function refetchSalesQuery(variables?: SalesQueryVariables) {
      return { query: SalesDocument, variables: variables }
    }